import React from 'react';
import { Check } from 'lucide-react';

const StepProgress = ({ currentStep, totalSteps }) => {
  return (
    <div className="step-progress">
      {Array.from({ length: totalSteps }, (_, i) => {
        const stepNumber = i + 1;
        const isCompleted = i < currentStep;
        const isActive = i === currentStep;
        
        return (
          <div
            key={i}
            className={`step-dot ${
              isCompleted ? 'completed' : 
              isActive ? 'active' : ''
            }`}
          >
            {isCompleted ? (
              <Check className="w-4 h-4" />
            ) : (
              stepNumber
            )}
          </div>
        );
      })}
      
      <div className="step-info">
        Step {currentStep + 1} of {totalSteps}
      </div>
    </div>
  );
};

export default StepProgress;